import {useCallback, useContext, useDebugValue} from 'react';
import context from '.';
import * as Utils from '@root/lib/services/UtilService';

/**
 *
 * @returns {[
 *   {
 *     isReturn: boolean;
 *     inProcessingWindow?: boolean;
 *     sectionSorting: string[];
 *     sidecartHeaderAndFooterColor: string;
 *     showDots: boolean;
 *     showBestSellersInitialFlow: boolean;
 *     showBestSellersReturnFlow: boolean;
 *     dotColorActive: string;
 *     dotColorInactive: string;
 *     deliveryDays: string[],
 *     minMeals: number;
 *     maxMeals: number;
 *     mealMealsFreeShipping: number;
 *     minDollarsFreeShipping: number;
 *     futureOrderDate?: string;
 *     incompatSubscription?: boolean;
 *
 *     subscription?: {
 *       bold_platform_subscription_id: number;
 *     };
 *   },
 *   () => boolean,
 *   (flag: boolean) => void,
 *   (stateOrFn: Object|Function) => void,
 * ]}
 */
const useSettings = () => {
  const {state, setState, stateRef} = useContext(context);
  const {settings} = state;

  /**
   * Checks if the settings are loading
   */
  const isLoading = useCallback(() => {
    const {settings} = stateRef.current;
    return settings.loading;
  }, []);

  /**
   * Sets the loading flag for the settings state
   *
   * @type {(flag: boolean) => void}
   */
  const setLoading = useCallback((flag) => {
    Utils.setNestedImmutably('settings.loading', flag).setWith(setState);
  }, []);

  /**
   * Sets the settings state in the global state
   *
   * @type {(stateOrFn) => void}
   */
  const setSettings = useCallback((stateOrFn) => {
    setState((ps) => ({
      ...ps,
      settings: {
        ...ps.settings,
        state: typeof stateOrFn === 'function'
          ? stateOrFn(ps.settings.state)
          : stateOrFn,
      },
    }));
  }, []);

  useDebugValue(state.settings);
  return [
    settings.state,
    {
      isLoading,
      setLoading,
      setSettings,
    },
  ];
};

export default useSettings;
